import type { ThemeChoices } from "$/lib/types/General.types";
import { useId } from "react";
import {
  AreaChart as AChart,
  Area,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import AreaGraphCustomTooltip from "./AreaGraphCustomTooltip";

interface Props {
  theme?: ThemeChoices;
  data: { name: string; value: number }[];
}

// const data = [
//   {
//     name: "14/01/2025",
//     uv: 62.57,
//   },
//   {
//     name: "15/01/2025",
//     uv: 56.67,
//   },
//   {
//     name: "16/01/2025",
//     uv: 44.21,
//   },
//   {
//     name: "17/01/2025",
//     uv: 38.77,
//   },
//   {
//     name: "18/01/2025",
//     uv: 48.21,
//   },
//   {
//     name: "19/01/2025",
//     uv: 35,
//   },
//   {
//     name: "20/01/2025",
//     uv: 62.57,
//   },
// ];

const AreaGraph = ({ theme = "blue", data }: Props) => {
  const themeColors = {
    blue: "#183E7A",
    green: "#84BCAF",
    orange: "#F8AE53",
  };

  const themeColor = themeColors[theme];

  const colorId = useId();
  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={122}>
      <AChart width={500} height={400} data={data}>
        <defs>
          <linearGradient id={colorId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={themeColor} stopOpacity={0.6} />
            <stop offset="95%" stopColor={themeColor} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Tooltip content={AreaGraphCustomTooltip} />
        <Area
          type="monotone"
          dataKey="value"
          stroke={themeColor}
          fillOpacity={1}
          fill={`url(#${colorId})`}
        />
      </AChart>
    </ResponsiveContainer>
  );
};

export default AreaGraph;
